import { XIcon } from "@heroicons/react/solid";
import { Dialog } from "@mui/material";
import useGetComponentsForTemplate from "../../hooks/salaryTemplates/useGetComponentsForTemplate";
import { useState } from "react";
import { Button } from "../ui";
import Pagination from "../pagination";

const AddComponentRowModal = ({
  isOpen,
  toggleModal,
  addRows,
  addedRows = [],
}) => {
  const { componentsList, pagination, isListLoading, handlePageClick } =
    useGetComponentsForTemplate();

  const [addedComponents, setAddedComponents] = useState([]);

  const includesComponent = (component) => {
    return addedComponents.some(
      (comp) => comp.component_id === component.component_id
    );
  };

  const removeComponent = (component) => {
    setAddedComponents(
      addedComponents.filter(
        (comp) => comp.component_id !== component.component_id
      )
    );
  };

  const addComponent = (component) => {
    setAddedComponents([...addedComponents, component]);
  };

  const isAddedAlready = (component) => {
    return addedRows.some((comp) => {
      return comp?.component_id === component?.component_id;
    });
  };

  return (
    <Dialog open={isOpen} onClose={toggleModal} maxWidth="sm" fullWidth>
      <div className="p-4">
        <div className="mb-5">
          <div className="flex justify-between mb-4">
            <h4 className="text-xl font-semibold">Add Component Row</h4>
            <Button
              onClick={toggleModal}
              className="text-gray-500"
              variant={"ghost"}
            >
              <XIcon className="w-5 h-5 text-gray-600" />
            </Button>
          </div>

          {isListLoading && (
            <p className="w-full text-center py-10">Loading...</p>
          )}

          {componentsList?.map((component) => (
            <div
              key={component.id}
              className="flex items-center justify-between py-3 border-b"
            >
              <span>{component.name}</span>
              {isAddedAlready(component) ? (
                <p className="text-neutral-500">Selected already</p>
              ) : includesComponent(component) ? (
                <Button
                  className="text-red-500 font-medium"
                  onClick={() => removeComponent(component)}
                  variant={"ghost"}
                >
                  Remove
                </Button>
              ) : (
                <Button
                  variant="ghost"
                  className="text-green-600 font-medium"
                  onClick={() => addComponent(component)}
                >
                  Select
                </Button>
              )}
            </div>
          ))}
        </div>

        <Pagination
          className={"mt-5 w-full text-sm !justify-center"}
          currentPage={pagination.current_page_number}
          lengthofItems={+pagination.total_count}
          limit={pagination.per_page_limit}
          onPageChange={handlePageClick}
        />

        <div className="mt-5">
          <p className="font-semibold">Selected Components:</p>
          <p>
            {addedComponents.map((el, idx) => {
              return el.name + (idx < addedComponents.length - 1 ? ", " : "");
            })}
            <span className="text-neutral-400">
              {addedComponents.length === 0 && "No components selected yet"}
            </span>
          </p>
        </div>

        <div className="flex justify-end mt-5">
          <Button onClick={() => addRows(addedComponents)}>
            Add Components
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default AddComponentRowModal;
